var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconEmployee = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(49)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-35,20h-9.918c.556-3.388,3.9-6,7.918-6a8.759,8.759,0,0,1,4.488,1.207,1,1,0,0,0,1.371-.348,1,1,0,0,0-.347-1.371,10.432,10.432,0,0,0-1.76-.81A5.987,5.987,0,0,0-31,8a6,6,0,0,0-6-6,6,6,0,0,0-6,6,5.985,5.985,0,0,0,2.234,4.668A9.068,9.068,0,0,0-47,21a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1A1,1,0,0,0-35,20ZM-41,8a4,4,0,0,1,4-4,4,4,0,0,1,4,4,4,4,0,0,1-4,4A4,4,0,0,1-41,8Zm14,11a1,1,0,0,1-1,1h-1v1a1,1,0,0,1-1,1,1,1,0,0,1-1-1V20h-1a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1V17a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h1A1,1,0,0,1-27,19Z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmployee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-employee.c2d81ab3.svg";
export { ForwardRef as ReactComponent };